import { GelParagraph } from "@tal-gel/components";
import { getGelTokens } from "@tal-gel/theming";

const Paragraph = ({ content, marginTop }) => {
  return (
    <>
      {content.split(/\n/).map((p, i) => (
        <GelParagraph
          key={i}
          marginTop={marginTop}
          marginBottom={getGelTokens().global.sizeBaseX4}
        >
          {p}
        </GelParagraph>
      ))}
    </>
  );
};

export default Paragraph;
